import {
  http,
  ApplicationPayload,
  ApplicationResponse,
  DocumentsResponse,
  getApplicationEndpoint,
  getRequiredDocumentsEndpoint,
  RequiredDocumentsPayload,
  // ApplicationSchema,
} from "@/services";
import { AxiosRequestConfig } from "axios";
import { appendQueryToUrl } from "@/utils";

export const requestApplications = (
  { email, appRequest }: { email: string; appRequest: ApplicationPayload },
  config?: AxiosRequestConfig,
) => {
  const url = appendQueryToUrl(getApplicationEndpoint, { email });

  return http.post<ApplicationResponse>(url, { ...appRequest }, config);
  // .then(ApplicationSchema.parse);
};

export const requestRequiredDocuments = (
  data: RequiredDocumentsPayload,
  config?: AxiosRequestConfig,
) => {
  return http.get<DocumentsResponse>(
    getRequiredDocumentsEndpoint,
    { ...data },
    config,
  );
};
